var _I18nManager=require('../I18nManager');var _I18nManager2=_interopRequireDefault(_I18nManager);
var _multiplyStyleLengthValue=require('../../modules/multiplyStyleLengthValue');var _multiplyStyleLengthValue2=_interopRequireDefault(_multiplyStyleLengthValue);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}

/**
 * Map of property names to their BiDi equivalent.
 */
var PROPERTIES_TO_SWAP={
'borderTopLeftRadius':'borderTopRightRadius',
'borderTopRightRadius':'borderTopLeftRadius',
'borderBottomLeftRadius':'borderBottomRightRadius',
'borderBottomRightRadius':'borderBottomLeftRadius',
'borderLeftColor':'borderRightColor',
'borderLeftStyle':'borderRightStyle',
'borderLeftWidth':'borderRightWidth',
'borderRightColor':'borderLeftColor',
'borderRightWidth':'borderLeftWidth',
'borderRightStyle':'borderLeftStyle',
'left':'right',
'marginLeft':'marginRight',
'marginRight':'marginLeft',
'paddingLeft':'paddingRight',
'paddingRight':'paddingLeft',
'right':'left'};


var PROPERTIES_SWAP_LEFT_RIGHT={
'clear':true,
'float':true,
'textAlign':true};


var PROPERTIES_SWAP_LTR_RTL={
'writingDirection':true};


/**
 * Invert the sign of a numeric-like value
 */
var additiveInverse=function additiveInverse(value){return(0,_multiplyStyleLengthValue2.default)(value,-1);};

/**
 * BiDi flip the given property.
 */
var flipProperty=function flipProperty(prop){
return PROPERTIES_TO_SWAP.hasOwnProperty(prop)?PROPERTIES_TO_SWAP[prop]:prop;};


/**
 * BiDi flip translateX
 */
var flipTransform=function flipTransform(transform){
var translateX=transform.translateX;
if(translateX!=null){
transform.translateX=additiveInverse(translateX);}

return transform;};


var swapLeftRight=function swapLeftRight(value){
return value==='left'?'right':value==='right'?'left':value;};


var swapLtrRtl=function swapLtrRtl(value){
return value==='ltr'?'rtl':value==='rtl'?'ltr':value;};


var i18nStyle=function i18nStyle(){var style=arguments.length<=0||arguments[0]===undefined?{}:arguments[0];
var newStyle={};
for(var prop in style){
if(style.hasOwnProperty(prop)){
var indexOfNoFlip=prop.indexOf('$noI18n');

if(_I18nManager2.default.isRTL){
if(PROPERTIES_TO_SWAP[prop]){
var newProp=flipProperty(prop);
newStyle[newProp]=style[prop];}else
if(PROPERTIES_SWAP_LEFT_RIGHT[prop]){
newStyle[prop]=swapLeftRight(style[prop]);}else
if(PROPERTIES_SWAP_LTR_RTL[prop]){
newStyle[prop]=swapLtrRtl(style[prop]);}else
if(prop==='textShadowOffset'){
newStyle[prop]=style[prop];
newStyle[prop].width=additiveInverse(style[prop].width);}else
if(prop==='transform'){
newStyle[prop]=style[prop].map(flipTransform);}else
if(indexOfNoFlip>-1){
var _newProp=prop.substring(0,indexOfNoFlip);
newStyle[_newProp]=style[prop];}else
{
newStyle[prop]=style[prop];}}else

{
if(indexOfNoFlip>-1){
var _newProp2=prop.substring(0,indexOfNoFlip);
newStyle[_newProp2]=style[prop];}else
{
newStyle[prop]=style[prop];}}}}





return newStyle;};


module.exports=i18nStyle;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-native-web/dist/apis/StyleSheet/i18nStyle.js
 ** module id = 503
 ** module chunks = 0
 **/